module.exports = __webpack_public_path__ + "img/frame-image.aca3d13f.svg";